import CPlusplus from './c-plusplus';

export default CPlusplus;
